import React, {useEffect, useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import {FormattedMessage, useIntl} from "react-intl";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {useDispatch} from "react-redux";
import useAppModalService from "../../../hooks/useAppModalService";
import {useGetAccountQuery, useLoginMutation} from "../../../stores/account/account.api";
import {loginAsync} from "../../../stores/account/account.thunks";
import ResetPasswordPopUp from "../ResetPasswordPopUp/ResetPasswordPopUp";

import './LoginPopUp.style.scss';
import GlobalConst from "../../../constants/GlobalConst";
import LoginFailedPopUp from "../LoginFailedPopUp/LoginFailedPopUp";
import PrivyLoginButton from "../../../components/Privy/PrivyLoginButton";



const LoginPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options}) => {

    const dispatch = useDispatch();
    const {openModal} = useAppModalService();
    const {data: userAccount} = useGetAccountQuery();

    const [login, {data, isLoading}] = useLoginMutation();
    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const intl = useIntl();


    const handleLoginFailed = async () => {
        await openModal('loginFailed', 'info', {
            title: 'Login Failed',
            modalComponent: LoginFailedPopUp,
            onClose: onClose,
        });
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        const userData = JSON.stringify({
            username: email,
            password: password,
            grant_type: "password"
        })

        let res;

        res = await dispatch(loginAsync(userData));
        if (res.payload) {
            onClose();
        } else {
            await handleLoginFailed();
        }

    }

    const handleForgotPassword = async () => {
        const currentUrl = window.location.href;
        window.location.href = `${GlobalConst.SITE_URLS.TRADEFAN}/Account/ForgotPassword?returnurl=${currentUrl}`;

        !GlobalConst.FEATURES.ENABLE_LEGACY_PAGES && await openModal('resetPassword', 'info', {
            title: 'Reset Password',
            modalComponent: ResetPasswordPopUp
        },);
    }

    const handleSignUp = () => {
        (window.location.href = '/register');
    }

    useEffect(() => {
    }, [data]);

    return (
        <Dialog open={open} onClose={onClose} className={"LoginPopUp"}>
            <DialogContent className={"loginPopUpContent"}>
                <div className={"closeButton"} onClick={onClose}>X</div>
                <div className={"logo"}/>
                <Typography variant="h5" className={"title"}>
                    <FormattedMessage id={"popUp.login.title"}/>
                </Typography>
                <form className="loginForm" onSubmit={handleLogin}>
                    <div className="formGroup">
                        <label>
                            <FormattedMessage id={"popUp.login.userNameOrEmail"}/>
                        </label>
                        <input
                            id="username"
                            type="text"
                            placeholder={intl.formatMessage({id:'popUp.login.userNameOrEmail'})}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {emailError && <span className="error">{emailError}</span>}
                    </div>

                    <div className="formGroup">
                        <label>
                            <FormattedMessage id={"popUp.login.password"}/>
                        </label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder={intl.formatMessage({id:'popUp.login.password'})}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        /><i className="fa-solid fa-eye" onClick={ () => {
                        setShowPassword(!showPassword)
                    }} />
                        {passwordError && <span className="error">{passwordError}</span>}
                    </div>
                    <DialogActions className={"dialogActions"}>
                        <Button type="submit" variant="contained" className={"loginButton"}>
                            <FormattedMessage id={"popUp.login.login"}/>
                        </Button>
                    </DialogActions>
                </form>
                <Typography className="forgotPassword" align="center" color="primary" onClick={() => {
                    onClose();
                    handleForgotPassword();
                }}>
                    <FormattedMessage id={"popUp.login.forgotPassword"}/>
                </Typography>
                <div className="dontHaveAccount"><FormattedMessage id={'popUp.login.dontHaveAnAccount'}/></div>
                <div className="signUp" onClick={() => handleSignUp()
                }><FormattedMessage id={'popUp.login.signUp'}/></div>

                {/*<div className={"privyLoginContainer"}>
                    <div className={"or"}><span><FormattedMessage id={'popUp.login.or'}/></span></div>
                    <div className={"or-text"}>
                        <FormattedMessage id={'popUp.login.orText'}/>
                    </div>
                    <PrivyLoginButton
                        onSuccess={() => {
                            console.log('Privy login successful, closing modal');
                            onClose();
                        }}
                        onError={(error) => {
                            console.error('Privy login error:', error);
                            handleLoginFailed();
                        }}
                    />
                </div>*/}
            </DialogContent>
        </Dialog>
    )
}

export default LoginPopUp;